"use client";

import { useEffect, useRef } from "react";

import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

import { TextElementNova } from "@/components/ui-kit/TextElementNova/TextElementNova";

import { HomepageHeroImageLayoutProps } from "./HomepageHeroImage.types";
import HomepageHeroImageTabs from "./HomepageHeroImageTabs";

gsap.registerPlugin(ScrollTrigger);

const HomepageHeroImageMobile = ({
  data,
  active,
  setActive,
  benefitsSection,
  imagesSection,
}: HomepageHeroImageLayoutProps) => {
  const { subheading, tabs } = data;
  const dividerRef = useRef<HTMLDivElement>(null);
  const tabRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const divider = dividerRef.current;
    const tab = tabRef.current;
    if (!divider || !tab) return;

    /* Overshoot by the bullet size so the bullet parks behind the tab. */
    const getDividerHeight = () =>
      tab.getBoundingClientRect().top - divider.getBoundingClientRect().top + 8;
    const tween = gsap.fromTo(
      divider,
      { height: 0 },
      {
        height: getDividerHeight,
        duration: 1.2,
        ease: "power1.inOut",
        scrollTrigger: {
          trigger: tab,
          start: "top 95%",
          toggleActions: "play none none none",
          invalidateOnRefresh: true,
        },
      }
    );
    const handleResize = () => gsap.set(divider, { height: getDividerHeight() });
    window.addEventListener("resize", handleResize);

    return () => {
      tween.kill();
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <div className="px-4 md:px-10">
      <div className="relative z-[1] pt-10 pb-7 md:pb-[63px]">
        <div className="mx-auto max-w-[296px] pb-10 md:max-w-[768px] md:pt-10 md:pb-[88px]">
          <TextElementNova
            text={subheading}
            element="h2"
            className="Title-20-Super-Normal text-center"
          />
        </div>
        <div className="relative mx-auto w-[90%] max-w-[360px]">
          <div
            ref={dividerRef}
            className="absolute left-1/2 top-full z-[2] w-px -translate-x-1/2 bg-nova-transparency-black-20"
          >
            <span className="absolute -right-[3px] -bottom-2 size-2 rounded-full bg-nova-brand-accent-80" />
          </div>
          {imagesSection}
        </div>
      </div>
      <div ref={tabRef}>
        <HomepageHeroImageTabs tabs={tabs} setter={setActive} active={active} />
      </div>
      <div className="pt-8">{benefitsSection}</div>
    </div>
  );
};

export default HomepageHeroImageMobile;
